import { render, staticRenderFns } from "./message-call-group.vue?vue&type=template&id=35b1a300&scoped=true"
import script from "./message-call-group.vue?vue&type=script&lang=ts"
export * from "./message-call-group.vue?vue&type=script&lang=ts"
import style0 from "./message-call-group.vue?vue&type=style&index=0&id=35b1a300&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1a300",
  null
  
)

export default component.exports